module.exports = __webpack_public_path__ + "img/45_18.8064d7ae.png";